import { render, staticRenderFns } from "./modelDwgList.vue?vue&type=template&id=f2c604ca&scoped=true&lang=pug"
import script from "./modelDwgList.vue?vue&type=script&lang=js"
export * from "./modelDwgList.vue?vue&type=script&lang=js"
import style0 from "./modelDwgList.vue?vue&type=style&index=0&id=f2c604ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c604ca",
  null
  
)

export default component.exports